<template>
  <intervencion-activa-list-component :tipo-modulo="TIPO_MODULO_INTERVENCION.ACADEMIA" />
</template>

<script>
import IntervencionActivaListComponent from '@/components/intervencion/IntervencionActivaListComponent.vue'
import { TIPO_MODULO_INTERVENCION } from '@/modules/intervencion-c3/domain/tipoModuloIntervencion'

export default {
  name: 'AcademiaIntervencionActiva',
  components: {
    IntervencionActivaListComponent,
  },
  data() {
    return {
      TIPO_MODULO_INTERVENCION,
    }
  },
}
</script>
